"use client";

import React, { useState, useEffect } from "react";
import { useOnboarding } from "./OnboardingContext";

// Modal examples
import ModalCompanyContextExample from "@/examples/modals/ModalCompanyContextExample";
import ModalSupplierSelectionExample from "@/examples/modals/ModalSupplierSelectionExample";
import ModalDataTypesSuggestExample from "@/examples/modals/ModalDataTypesSuggestExample";
import ModalDataPoolsSuggestExample from "@/examples/modals/ModalDataPoolsSuggestExample";
import ModalProcessesSuggestExample from "@/examples/modals/ModalProcessesSuggestExample";
import ModalPrivacyPolicyImportExample from "@/examples/modals/ModalPrivacyPolicyImportExample";
import ModalCollectionNoticeImportExample from "@/examples/modals/ModalCollectionNoticeImportExample";
import ModalControlQuestionsExample from "@/examples/modals/ModalControlQuestionsExample";
import ModalAssuranceTaskSchedulingExample from "@/examples/modals/ModalAssuranceTaskSchedulingExample";

export function OnboardingHost() {
  const { activeStep } = useOnboarding();
  const [mountKey, setMountKey] = useState(0);

  // Increment mount key whenever activeStep changes to force remount
  // This ensures the modal's internal open state resets
  useEffect(() => {
    if (activeStep) {
      setMountKey(k => k + 1);
    }
  }, [activeStep]);

  if (!activeStep) return null;

  // Use combined key to force remount when reopening the same step
  const key = `${activeStep}-${mountKey}`;
  
  switch (activeStep) {
    case "company_context":
      return <ModalCompanyContextExample key={key} />;
    case "add_suppliers":
      return <ModalSupplierSelectionExample key={key} />;
    case "data_labels":
      return <ModalDataTypesSuggestExample key={key} />;
    case "data_pools":
      return <ModalDataPoolsSuggestExample key={key} />;
    case "add_processes":
      return <ModalProcessesSuggestExample key={key} />;
    case "import_privacy_policy":
      return <ModalPrivacyPolicyImportExample key={key} />;
    case "import_collection_notice":
      return <ModalCollectionNoticeImportExample key={key} />;
    case "control_selection":
      return <ModalControlQuestionsExample key={key} />;
    case "assurance_task_scheduling":
      return <ModalAssuranceTaskSchedulingExample key={key} />;
    default:
      return null;
  }
}
